var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('div',{staticClass:"hero"},[_c('Slider',{attrs:{"photo-swipe":true,"data":_vm.items}}),_c('div',{staticClass:"hero__content container"},[_c('RichText',{staticClass:"hero__slogan",attrs:{"value":_vm.description || _vm.item.description}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }